{
  "COMPOSE_REDIRECT": {
    "OPENING": "Åbner en ny samtale med {email}…",
    "NO_EMAIL": "Ingen e-mailadresse angivet. Brug ?email=name@example.com",
    "CONTACT_ERROR": "Kunne ikke finde kontakten for {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Vælg venligst en samtale fra venstre rude",
    "CSAT_REPLY_MESSAGE": "Bedøm venligst samtalen",
    "404": "Beklager, vi kan ikke finde samtalen. Prøv igen",
    "SWITCH_VIEW_LAYOUT": "Skift layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Beskeder",
    "UNVERIFIED_SESSION": "Identiteten af denne bruger er ikke bekræftet",
    "NO_MESSAGE_1": "Åh oh! Det ser ud til, at der ikke er nogen beskeder fra kunder i din indbakke.",
    "NO_MESSAGE_2": " for at sende en besked til din side!",
    "NO_INBOX_1": "Hola! Det ser ud til, at du endnu ikke har tilføjet indbakker.",
    "NO_INBOX_2": " for at komme i gang",
    "NO_INBOX_AGENT": "Åh Åh! Det ser ud til, at du ikke er en del af en indbakke. Kontakt venligst din administrator",
    "SEARCH_MESSAGES": "Søg efter beskeder i samtaler",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Oversættelse",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Søg efter beskeder",
      "RESULT_TITLE": "Søgeresultater",
      "LOADING_MESSAGE": "Behandler data...",
      "PLACEHOLDER": "Skriv tekst for at søge i beskeder",
      "NO_MATCHING_RESULTS": "Ingen resultater fundet."
    },
    "UNREAD_MESSAGES": "Ulæste Beskeder",
    "UNREAD_MESSAGE": "Ulæst Besked",
    "CLICK_HERE": "Klik her",
    "LOADING_INBOXES": "Indlæser indbakker",
    "LOADING_CONVERSATIONS": "Indlæser Samtaler",
    "CANNOT_REPLY": "Du kan ikke svare på grund af",
    "24_HOURS_WINDOW": "24 timers beskedvindue begrænsning",
    "NOT_ASSIGNED_TO_YOU": "Denne samtale er ikke tildelt dig. Vil du tildele denne samtale til dig selv?",
    "ASSIGN_TO_ME": "Tildel til mig",
    "TWILIO_WHATSAPP_CAN_REPLY": "Du kan kun svare på denne samtale ved hjælp af en skabelon besked på grund af",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 timers beskedvindue begrænsning",
    "REPLYING_TO": "Du svarer til:",
    "REMOVE_SELECTION": "Fjern Markering",
    "DOWNLOAD": "Download",
    "UNKNOWN_FILE_TYPE": "Ukendt Fil",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Udfør inden afsendelse:",
      "EXECUTE": "Udfør",
      "RETRY": "Prøv igen",
      "CONFIRM": "Udfør nu?",
      "CONFIRM_YES": "Ja, udfør",
      "CONFIRM_NO": "Annuller",
      "RUNNING": "Udføres…",
      "DONE": "Udført",
      "CLAIM_DELAYED": "oprettes, når ordren er leveret",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Der er oprettet en NY reklamation {reference}, {planned} er lukket — ret udkastets tekst",
        "NEW_CLAIM": "Der er oprettet en NY reklamation {reference} i stedet for at opdatere {planned} — ret udkastets tekst",
        "OTHER_CLAIM": "Reklamation {reference} er opdateret i stedet for {planned} — ret udkastets tekst",
        "EXISTING_CLAIM": "Der er ikke oprettet en ny reklamation, den eksisterende {reference} er opdateret — ret udkastets tekst",
        "OTHER": "Det forløb anderledes, end udkastet forudsatte — ret udkastets tekst"
      },
      "FAILED": "Mislykkedes",
      "UNREACHABLE": "Botten kunne ikke kontaktes",
      "REQUEST_FAILED": "Handlingen kunne ikke startes. Prøv igen.",
      "ACTIONS": {
        "CANCEL_ORDER": "Annuller ordren",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Skift betalingen til efterkrav",
        "CREATE_CLAIM": "Opret en reklamation",
        "CREATE_OR_UPDATE_CLAIM": "Opret eller opdater en reklamation",
        "EXTEND_ORDER_PICKUP_DATE": "Forlæng afhentningsfristen"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Uploader vedhæftede filer...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Besked slettet",
    "FAIL_DELETE_MESSSAGE": "Kunne ikke slette beskeden! Prøv igen",
    "NO_RESPONSE": "Intet svar",
    "RESPONSE": "Response",
    "RATING_TITLE": "Bedømmelse",
    "FEEDBACK_TITLE": "Tilbagemelding",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Vis etiketter",
      "HIDE_LABELS": "Skjul etiketter"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Løs",
      "REOPEN_ACTION": "Genåben",
      "OPEN_ACTION": "Åbn",
      "OPEN": "Mere",
      "CLOSE": "Luk",
      "DETAILS": "detaljer",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Udsat til i morgen",
      "SNOOZED_UNTIL_NEXT_WEEK": "Udsat indtil næste uge",
      "SNOOZED_UNTIL_NEXT_REPLY": "Udsat indtil næste svar",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Markér som afventende",
      "SNOOZE_UNTIL": "Udsæt",
      "SNOOZE": {
        "TITLE": "Udsæt til",
        "NEXT_REPLY": "Næste svar",
        "TOMORROW": "I Morgen",
        "NEXT_WEEK": "Næste uge"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Udsæt til",
      "APPLY": "Udsæt",
      "CANCEL": "Annuller"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Ingen",
        "URGENT": "Haster",
        "HIGH": "Høj",
        "MEDIUM": "Mellem",
        "LOW": "Lav"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ingen",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Ingen resultater fundet",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Åbn i ny fane",
      "COPY_LINK": "Kopiér link til samtalen",
      "COPY_LINK_SUCCESS": "Link til samtalen kopieret til udklipsholderen",
      "PENDING": "Markér som afventende",
      "RESOLVED": "Marker som løst",
      "MARK_AS_UNREAD": "Marker som ulæst",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Genåbn samtale",
      "SNOOZE": {
        "TITLE": "Udsæt",
        "NEXT_REPLY": "Indtil næste svar",
        "TOMORROW": "Indtil i morgen",
        "NEXT_WEEK": "Indtil næste uge"
      },
      "ASSIGN_AGENT": "Tildel agent",
      "ASSIGN_LABEL": "Tildel etiket",
      "AGENTS_LOADING": "Indlæser agenter...",
      "ASSIGN_TEAM": "Tildel team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Samtale id {conversationId} tildelt \"{agentName}\"",
          "FAILED": "Kunne ikke tildele agent. Prøv venligst igen."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Kunne ikke tildele etiket. Prøv venligst igen."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Tildelt team \"{team}\" til samtale-id {conversationId}",
          "FAILED": "Kunne ikke tildele team. Prøv venligst igen."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Besked signatur",
      "ENABLE_SIGN_TOOLTIP": "Aktiver signatur",
      "DISABLE_SIGN_TOOLTIP": "Deaktivér signatur",
      "MSG_INPUT": "Shift + enter for ny linje. Start med '/' for at vælge et standardsvar.",
      "PRIVATE_MSG_INPUT": "Shift + enter for ny linje. Dette vil kun være synligt for Agenter",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Beskedsignatur er ikke konfigureret, konfigurer den i profilindstillinger.",
      "CLICK_HERE": "Klik her for at opdatere",
      "WHATSAPP_TEMPLATES": "Whatsapp Skabeloner",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "WhatsApp-vinduet på 24 timer er udløbet. Svar med en skabelon.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Dit svar ser ud til at være på {draftLanguage}, men denne samtale er på {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Oversæt",
      "REPLY": "Svar",
      "PRIVATE_NOTE": "Privat Note",
      "SEND": "Send",
      "CREATE": "Tilføj Note",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Vis rig teksteditor",
      "HEADING_LEVEL": {
        "LABEL": "Tekststil",
        "NORMAL": "Normal tekst",
        "H1": "Overskrift 1",
        "H2": "Overskrift 2",
        "H3": "Overskrift 3"
      },
      "EDITOR": {
        "BOLD": "Fed",
        "ITALIC": "Kursiv",
        "UNDERLINE": "Understreget",
        "TEXT_COLOR": "Tekstfarve",
        "BG_COLOR_LABEL": "Baggrundsfarve",
        "FONT_SIZE_LABEL": "Skriftstørrelse",
        "FONT_SIZE": {
          "XS": "Lille",
          "SM": "Mellem lille",
          "MD": "Standard",
          "LG": "Stor",
          "XL": "Ekstra stor",
          "XXL": "Enorm"
        },
        "CODE": "Kode",
        "LINK": "Tilføj eller fjern link",
        "CREATE_LINK": "Opret link",
        "SAVE_LINK": "Gem",
        "CANCEL": "Annuller",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Fortryd",
        "REDO": "Gentag",
        "BULLET_LIST": "Punktopstilling",
        "ORDERED_LIST": "Nummereret liste",
        "BLOCKQUOTE": "Citat",
        "H1": "Overskrift 1",
        "H2": "Overskrift 2",
        "H3": "Overskrift 3",
        "IMAGE_UPLOAD": "Upload billede",
        "CLEAR_FORMATTING": "Ryd formatering",
        "COLOR": {
          "RED": "Rød",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Rosenrød",
          "DEEP_CYAN": "Mørk cyan",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistacie",
          "PURPLE": "Lilla",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Sølv",
          "NAVY": "Marineblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Akvamarin",
          "BROWN": "Brun",
          "OLIVE": "Oliven",
          "GOLD": "Guld",
          "BEIGE": "Beige",
          "WINE": "Vinrød",
          "FOREST": "Skovgrøn",
          "GREEN": "Grøn",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinrød",
          "CHESTNUT_BROWN": "Kastaniebrun",
          "ASH_GREY": "Askegrå"
        },
        "BG_COLOR": {
          "RED": "Rød",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Rosenrød",
          "DEEP_CYAN": "Mørk cyan",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistacie",
          "PURPLE": "Lilla",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Sølv",
          "NAVY": "Marineblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Akvamarin",
          "BROWN": "Brun",
          "OLIVE": "Oliven",
          "GOLD": "Guld",
          "BEIGE": "Beige",
          "WINE": "Vinrød",
          "FOREST": "Skovgrøn",
          "GREEN": "Grøn",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinrød",
          "CHESTNUT_BROWN": "Kastaniebrun",
          "ASH_GREY": "Askegrå"
        }
      },
      "TIP_EMOJI_ICON": "Vis emoji-vælger",
      "TIP_ATTACH_ICON": "Vedhæft filer",
      "TIP_AUDIORECORDER_ICON": "Optag lyd",
      "TIP_AUDIORECORDER_PERMISSION": "Tillad adgang til lyd",
      "TIP_AUDIORECORDER_ERROR": "Kunne ikke åbne lyden",
      "DRAG_DROP": "Træk og slip her for at vedhæfte",
      "START_AUDIO_RECORDING": "Start lydoptagelse",
      "STOP_AUDIO_RECORDING": "Stop lydoptagelse",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Tilføj bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-mails adskilt af kommaer",
          "ERROR": "Indtast venligst gyldige e-mailadresser"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-mails adskilt af kommaer",
          "ERROR": "Indtast venligst gyldige e-mailadresser"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Annuller"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Tilføj en SMS-indbakke for at sende SMS-svar.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privat Note: Kun synlig for dig og dit team",
    "CHANGE_STATUS": "Samtalestatus ændret",
    "CHANGE_STATUS_FAILED": "Ændring af samtale status mislykkedes",
    "CHANGE_AGENT": "Samtaleansvarlig ændret",
    "CHANGE_AGENT_FAILED": "Ændring af ansvarlig mislykkedes",
    "ASSIGN_LABEL_SUCCESFUL": "Label tildelt",
    "ASSIGN_LABEL_FAILED": "Tildeling af etiket mislykkedes",
    "CHANGE_TEAM": "Samtaleholdet er ændret",
    "FILE_SIZE_LIMIT": "Filen overskrider grænsen på {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} for vedhæftede filer",
    "MESSAGE_ERROR": "Kunne ikke sende denne besked, prøv igen senere",
    "SENT_BY": "Sendt af:",
    "BOT": "Bot",
    "SEND_FAILED": "Kunne ikke sende besked! Prøv igen",
    "TRY_AGAIN": "prøv igen",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Vælg Agent",
      "REMOVE": "Fjern",
      "ASSIGN": "Tildel"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiér",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Slet",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Slet",
        "CANCEL": "Annuller"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Samtalen blev markeret som løst af {userName}",
          "CONTACT_RESOLVED": "Samtalen blev løst af {contactName}",
          "OPEN": "Samtalen blev genåbnet af {userName}",
          "PENDING": "Samtalen blev markeret som afventende af {userName}",
          "SNOOZED": "Samtalen blev udskudt af {userName}",
          "AUTO_RESOLVED": "Samtalen blev markeret som løst af systemet på grund af {duration} dages inaktivitet",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Systemet markerede samtalen som løst, fordi ticketten blev lukket på Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} selv-tildelte denne samtale",
          "ASSIGNED": "Tildelt {assigneeName} af {userName}",
          "REMOVED": "Samtale fjernet tildeling af {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Tildelt {teamName} af {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Tildelt {assigneeName} via {teamName} af {userName}",
          "REMOVED": "Ikke tildelt fra {teamName} af {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} tilføjede {labels}",
          "REMOVED": "{userName} fjernede {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} har slukket for samtalen",
        "UNMUTED": "{userName} har genaktiveret samtalen",
        "CONTACT_BLOCKED": "{userName} blokerede kontakten",
        "CONTACT_UNBLOCKED": "{userName} fjernede blokeringen af kontakten",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Flyttet, fordi kontaktens ordrer kun kommer fra butikken {storeName} (seneste ordre {orderId}), hvis robot svarer i denne indbakke.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatiseringen blev sprunget over, fordi kontakten er blokeret",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatiseringen \"{ruleName}\" kunne ikke flytte denne samtale fra indbakken {sourceInboxName} til indbakken {targetInboxName}, fordi indbakkerne ikke er kompatible.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke flytte denne samtale fra indbakken {sourceInboxName} til indbakken {targetInboxName}, fordi kontakten ikke har en e-mailadresse.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatisering \"{ruleName}\" kunne ikke sende en besked: denne telefonindbakke kan ikke sende sms, fordi kontoen ikke har nogen sms-indbakke. Reglen blev slået fra, og administratorerne har fået en e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatisering \"{ruleName}\" kunne ikke sende en besked: vedhæftninger kan ikke sendes som sms fra denne indbakke. Reglen blev slået fra, og administratorerne har fået en e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macro \"{macroName}\" sendte ikke sin besked: denne telefonindbakke kan ikke sende sms, fordi kontoen ikke har nogen sms-indbakke.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macro \"{macroName}\" sendte ikke sin besked: vedhæftninger kan ikke sendes som sms fra denne indbakke.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macro \"{macroName}\" sendte ikke sin besked: botten håndterer denne samtale. Åbn samtalen først.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macro \"{macroName}\" sendte ikke sin besked: denne indbakke er markeret til sletning. Flyt først samtalen til en anden indbakke.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatiseringen \"{ruleName}\" sendte en e-mail til {contactEmail} i en ny samtale [#{conversationId}]({conversationPath}) i indbakken {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatiseringen \"{ruleName}\" startede denne samtale på grund af samtalen [#{conversationId}]({conversationPath}) i indbakken {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke sende beskeden i en ny samtale i indbakken {inboxName}, fordi kontakten ikke har en e-mailadresse.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatiseringen \"{ruleName}\" sendte en SMS til {contactPhone} i en ny samtale [#{conversationId}]({conversationPath}) i indbakken {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke sende SMS'en i en ny samtale i indbakken {inboxName}, fordi kontakten ikke har et telefonnummer.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Kunde"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "besvaret andetsteds, ringede i {duration}",
            "NO_ANSWER": "ikke besvaret, ringede i {duration}",
            "REJECTED": "afvist efter at have ringet i {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Løst automatisk efter {count} mislykkede tilbagekald",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Opkaldsoptagelsen blev slettet af {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Usynlig for kunden",
    "SENT_VIA_EMAIL": "Også sendt til kontakten via e-mail ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Denne indbakke er markeret til sletning, så kundens svar ville aldrig nå frem. Flyt samtalen til en anden indbakke for at svare.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Denne kontakt har en anden åben samtale #{id}",
      "MULTIPLE": "Denne kontakt har andre åbne samtaler ({count})",
      "OPEN": "Åbn",
      "SHOW": "Vis"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Bed kunden om at dele sit WhatsApp-telefonnummer",
      "PENDING_ACTION": "Anmodning om kontaktoplysninger afventer",
      "STATES": {
        "PENDING": "Venter på kontaktoplysninger",
        "SHARED": "Telefonnummer delt",
        "IDENTITY_CONFLICT": "Telefonnummer skal gennemgås"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send samtaleudskrift",
    "DESC": "Send en kopi af samtaleudskriften til den angivne e-mailadresse",
    "SUBMIT": "Send",
    "CANCEL": "Annuller",
    "SEND_EMAIL_SUCCESS": "Chatudskriften blev sendt med succes",
    "SEND_EMAIL_ERROR": "Der opstod en fejl. Prøv venligst igen",
    "FORM": {
      "SEND_TO_CONTACT": "Send udskrift til kunden",
      "SEND_TO_AGENT": "Send udskrift til den tildelte agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send udskriften til en anden e-mailadresse",
      "EMAIL": {
        "PLACEHOLDER": "Indtast en e-mail adresse",
        "ERROR": "Indtast venligst en gyldig e-mailadresse"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hej 👋, Velkommen til {installationName}!",
    "DESCRIPTION": "Tak for din tilmelding. Vi vil have dig til at få mest muligt ud af {installationName}. Her er et par ting, du kan gøre i {installationName} for at gøre oplevelsen dejlig.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Læs vores seneste opdateringer",
    "ALL_CONVERSATION": {
      "TITLE": "Alle dine samtaler på ét sted",
      "DESCRIPTION": "Se alle samtaler fra dine kunder på et enkelt betjeningspanel. Du kan filtrere samtaler efter indgående kanal, etiket og status.",
      "NEW_LINK": "Klik her for at oprette en indbakke"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Inviter dine teammedlemmer",
      "DESCRIPTION": "Da du er ved at blive klar til at tale med din kunde, skal du medbringe dine holdkammerater for at hjælpe dig. Du kan invitere dine holdkammerater ved at tilføje deres e-mailadresser til agentlisten.",
      "NEW_LINK": "Klik her for at invitere et teammedlem"
    },
    "LABELS": {
      "TITLE": "Organiser samtaler med etiketter",
      "DESCRIPTION": "Etiketter giver en lettere måde at kategorisere din samtale. Opret nogle etiketter som #support-forespørgsel, #billing-spørgsmål osv., så du kan bruge dem i en samtale senere.",
      "NEW_LINK": "Klik her for at oprette tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Tildelt Agent",
    "SELF_ASSIGN": "Tildel til mig",
    "TEAM_LABEL": "Tildelt Team",
    "SELECT": {
      "PLACEHOLDER": "Ingen"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Kontaktoplysninger",
      "CONVERSATION_ACTIONS": "Samtale Handlinger",
      "CONVERSATION_LABELS": "Samtale Etiketter",
      "CONVERSATION_INFO": "Samtale Information",
      "CONTACT_ATTRIBUTES": "Kontakt Attributter",
      "PREVIOUS_CONVERSATION": "Tidligere Samtaler",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Afventer",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Opret ny egenskab",
    "NO_RECORDS_FOUND": "Ingen attributter fundet",
    "UPDATE": {
      "SUCCESS": "Attributten er opdateret",
      "ERROR": "Kan ikke opdatere attributten. Prøv igen senere"
    },
    "ADD": {
      "TITLE": "Tilføj",
      "SUCCESS": "Egenskab tilføjet",
      "ERROR": "Kan ikke tilføje attribut. Prøv igen senere"
    },
    "DELETE": {
      "SUCCESS": "Attributten blev slettet",
      "ERROR": "Kan ikke slette attributten. Prøv igen senere"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Tilføj attributter",
      "PLACEHOLDER": "Søg attributter",
      "NO_RESULT": "Ingen attributter fundet"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Fra",
    "TO": "Til",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Emne"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Ingen resultater fundet",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Ordrenummer",
    "EXTERNAL_ID": "Eksternt ID",
    "PAYMENT_TYPE": "Betalingsmetode",
    "PAYMENT_DATE": "Betalingsdato",
    "DELIVERY_PROVIDER": "Fragtfirma",
    "EXPECTED_DATE_OF_DELIVERY": "Forventet levering",
    "DATE_OF_DELIVERY": "Leveret",
    "EXPEDITION_DATE": "Forsendelsesdato",
    "INTERNAL_NOTE": "Butiksnote",
    "PACKAGE_NUMBER": "Pakke"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
